import { createApi } from '@reduxjs/toolkit/query/react';
import { restBaseQuery } from 'shared/utils/api/rest-base-query';

export const restApi = createApi({
  reducerPath: 'restApi',
  baseQuery: restBaseQuery,
  // Расширяйте по мере необходимости, старайтесь переиспользовать единые теги
  tagTypes: ['RoleManager', 'Team'],
  endpoints: () => ({}),
});

export default restApi;
